import { supabase } from "../utils/supabaseClient";
import { DietaryPreference } from "../types/dietary";

/**
 * Fetch all dietary preferences for a branch
 */
export const getAllDietaryPreferences = async (branchId: string): Promise<DietaryPreference[]> => {
  try {
    const { data: result, error } = await supabase.rpc("get_dietary_preferences" as any, {
      payload: {
        branch_id: branchId
      }
    });

    if (error) {
      throw error;
    }

    if (!result || result.success === false) {
      return [];
    }

    return (result.data as DietaryPreference[]) || [];
  } catch (err) {
    throw err;
  }
};

/**
 * Fetch dietary preferences for a specific menu item
 */
export const getItemDietaryPreferences = async (
  itemId: string
): Promise<DietaryPreference[]> => {
  try {
    const { data, error } = await supabase.rpc("get_item_dietary", {
      p_item_id: itemId,
    });

    if (error) {
      throw error;
    }

    // Handle the response structure from the RPC function
    const response = data as unknown as {
      data: DietaryPreference[];
      message: string;
      success: boolean;
    };

    if (response.success && response.data) {
      return response.data;
    }

    return [];
  } catch (err) {
    console.error("Error fetching item dietary preferences:", err);
    throw err;
  }
};

/**
 * Fetch dietary preferences with selection status for a specific menu item
 */
export const getDietaryPreferencesWithSelection = async (
  itemId: string
): Promise<DietaryPreference[]> => {
  try {
    const { data, error } = await supabase.rpc("get_dietary_preferences_with_selection", {
      _item_id: itemId,
    });

    if (error) {
      throw error;
    }
    // Handle both possible RPC response shapes:
    if (data) {
      if (Array.isArray(data)) {
        return data as unknown as DietaryPreference[];
      }
      const maybeObj = data as unknown as {
        data?: DietaryPreference[];
        message?: string;
        success?: boolean;
      };
      if (maybeObj?.success && Array.isArray(maybeObj?.data)) {
        return (maybeObj.data ?? []) as DietaryPreference[];
      }
    }

    return [];
  } catch (err) {
    console.error("Error fetching dietary preferences with selection:", err);
    throw err;
  }
};
